function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.76 0h4.75c.32.08.64.19.96.24 14.54 2 25.37 16.05 20.3 32.73-3.23 10.62-13.44 17.39-24.74 17.01C13.3 49.63 3.82 42.02.98 31.48.63 30.16.33 28.83 0 27.5v-5c.31-1.29.58-2.59.95-3.86C3.9 8.72 10.44 2.65 20.55.43c.74-.15 1.48-.28 2.21-.43zM11.19 34.29l-.09.33c.53.29 1.05.61 1.59.86 11.05 4.97 23.54-2.68 24.1-14.8.05-1.13.35-1.97 1.25-2.67.57-.45.99-1.09 1.48-1.64l-.21-.21c-.7.17-1.4.34-2.24.54.7-1.03 1.27-1.87 1.85-2.71l-.28-.22c-.27.1-.54.19-.8.31-1.41.69-2.58.81-4.13-.18-3.85-2.45-8.84.44-8.95 5.07-.03 1.26-.47 1.48-1.57 1.3-3.74-.62-6.94-2.25-9.62-4.93-.33-.33-.7-.64-1.16-1.06-1.41 2.92-.71 5.31 1.28 7.71-.85-.11-1.39-.18-2.09-.26.16 2.78 1.66 4.48 4.17 5.72-.83.14-1.3.21-1.95.32.85 2.45 2.71 3.52 5.19 4.15-2.54 1.82-5.08 2.41-7.82 2.37z",
  fill: "#1BA1F2"
});

var SvgSourceTwitter = function SvgSourceTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_twitter.ec298e38.svg";
export { ForwardRef as ReactComponent };